import {Box, List} from '@mui/material';
import React from 'react';
import {RiskType} from '../../schema-types/globalTypes';
import {RiskNotesMenuItem} from './RiskNotesMenuItem';
import {riskNotesFormSectionType} from './riskNotesFields';

export const RiskNotesSideMenu: React.FC<{
  riskTypes: readonly RiskType[];
  currentRiskType: RiskType;
  setCurrentRiskType: React.Dispatch<React.SetStateAction<RiskType>>;
  readOnly: boolean;
  onToggleNoChange: (riskType: RiskType, section: riskNotesFormSectionType) => void;
}> = ({riskTypes, currentRiskType, setCurrentRiskType, readOnly, onToggleNoChange}) => {
  return (
    <Box>
      <List style={{paddingBottom: 0}} data-test="Required Notes">
        {riskTypes.map((riskType) => (
          <RiskNotesMenuItem
            key={riskType}
            menuItemRiskType={riskType}
            currentRiskType={currentRiskType}
            setCurrentRiskType={setCurrentRiskType}
            readOnly={readOnly}
            onToggleNoChange={onToggleNoChange}
          />
        ))}
      </List>
    </Box>
  );
};
